import React, { PropTypes } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import { FINANCE, HIGH_MANAGEMENT_WITH_MANAGER } from "../../../../../utils/Roles";
import { EnumWrapper } from "../../../../../utils/enums";
import { LANGUAGE_CODES } from "../../../../../utils/enums/enums";
import userHasAccess from "../../../../../utils/userHasAccess";
import { MANUAL } from "../../enums/billingPeriodTypes";
import ClientContacts from "../contacts/ClientContacts";
import InvoicingConfiguration from "../invoicing-configuration/InvoicingConfiguration";
import PersonalDataConfiguration from "../personal-data-configuration/PersonalDataConfiguration";
import WithdrawalConfigurationDataTable from "../withdrawal-configuration/WithdrawalConfigurationDataTable";
import { configurationEnums } from "./enums/ConfigurationEnums";
import Categorisation from "../../../clients/client/categorisation/Categorisation";

class ConfigurationForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            selectedFormSection: configurationEnums.CONTACTS,
        };

        this.setCurrentSection = this.setCurrentSection.bind(this);
        this.renderForm = this.renderForm.bind(this);
        this.getCanViewInvoicingConfig = this.getCanViewInvoicingConfig.bind(this);
    }

    getCanViewInvoicingConfig() {
        const { activeClient } = this.props;
        return activeClient && activeClient.isBillable && userHasAccess(FINANCE);
    }

    setCurrentSection(sectionName) {
        this.setState({ selectedFormSection: sectionName });
        /** Notify parent to refresh client status type on tab switch. */
        if (this.props.onTabChange) {
            this.props.onTabChange();
        }
    }

    renderForm(isMANUALClient = false) {
        switch (this.state.selectedFormSection) {
            case configurationEnums.CONTACTS:
                return (
                    <EnumWrapper showLoading={false} enum={LANGUAGE_CODES}>
                        <ClientContacts />
                    </EnumWrapper>
                );
            case configurationEnums.WITHDRAWAL:
                return isMANUALClient && (
                    <EnumWrapper showLoading={false} enum={LANGUAGE_CODES}>
                        <WithdrawalConfigurationDataTable />
                    </EnumWrapper>
                );
            case configurationEnums.PERSONAL_DATA:
                return isMANUALClient && (
                    <EnumWrapper showLoading={false} enum={LANGUAGE_CODES}>
                        <PersonalDataConfiguration />
                    </EnumWrapper>
                );
            case configurationEnums.INVOICING_CONFIG:
                return isMANUALClient && (
                    <EnumWrapper showLoading={false} enum={LANGUAGE_CODES}>
                        <InvoicingConfiguration />
                    </EnumWrapper>
                );
            case configurationEnums.CATEGORISATION:
                return (
                    <EnumWrapper showLoading={false} enum={LANGUAGE_CODES}>
                        <Categorisation/>
                    </EnumWrapper> 
                );
        }
    }

    render() {
        const { selectedFormSection } = this.state;
        const canViewInvoicingConfig = this.getCanViewInvoicingConfig();
        const clientBillingPeriodType = this.props.activeClient ? this.props.activeClient.clientBillingPeriodType : null;
        const isMANUALClient = clientBillingPeriodType === MANUAL.value;

        const canViewConfigurationTab = userHasAccess(FINANCE);
        const isHighManagementOrManager = userHasAccess(HIGH_MANAGEMENT_WITH_MANAGER,true);
        return (
            <div>
                <div className="sub-nav">
                    <ul className="flex">
                        <li>
                            <button
                                onClick={() => this.setCurrentSection(configurationEnums.CONTACTS)}
                                className={`nav-btn ${selectedFormSection === configurationEnums.CONTACTS
                                    ? "active-form-section"
                                    : ""
                                    }`}
                            >
                                <FormattedMessage id="clients.client.pages.contacts" />
                            </button>
                        </li>
                        {canViewConfigurationTab &&
                        <li>
                            <button
                                onClick={() => this.setCurrentSection(configurationEnums.CATEGORISATION)}
                                className={`nav-btn ${selectedFormSection === configurationEnums.CATEGORISATION && "active-form-section"}`}
                            >
                                <FormattedMessage id="clients.client.pages.classification" />
                            </button>
                        </li>
                        }
                        {
                            canViewInvoicingConfig && isMANUALClient && (
                                <li>
                                    <button
                                        onClick={() => this.setCurrentSection(configurationEnums.INVOICING_CONFIG)}
                                        className={`nav-btn ${selectedFormSection === configurationEnums.INVOICING_CONFIG
                                            ? "active-form-section"
                                            : ""
                                            }`}
                                    >
                                        <FormattedMessage id="clients.client.pages.invoicingConfig" />
                                    </button>
                                </li>
                            )
                        }
                        {
                            isHighManagementOrManager && isMANUALClient && (
                                <li>
                                    <button
                                        onClick={() => this.setCurrentSection(configurationEnums.WITHDRAWAL)}
                                        className={`nav-btn ${selectedFormSection === configurationEnums.WITHDRAWAL ? "active-form-section" : ""
                                            }`}
                                    >
                                        <FormattedMessage id="clients.client.pages.withdrawal" />
                                    </button>
                                </li>
                            )
                        }
                        {
                            isHighManagementOrManager && isMANUALClient && (
                                <li>
                                    <button
                                        onClick={() => this.setCurrentSection(configurationEnums.PERSONAL_DATA)}
                                        className={`nav-btn ${selectedFormSection === configurationEnums.PERSONAL_DATA
                                            ? "active-form-section"
                                            : ""
                                            }`}
                                    >
                                        <FormattedMessage id="clients.client.pages.personalData" />
                                    </button>
                                </li>
                            )
                        }
                    </ul >
                </div >
                {this.renderForm(isMANUALClient)}
            </div >
        );
    }
}

ConfigurationForm.propTypes = {
    activeClient: PropTypes.object,
    onTabChange: PropTypes.func,
};

function mapStateToProps(state) {
    return {
        activeClient: state.data.clients ? state.data.clients.active : null,
    };
}

export default connect(mapStateToProps, null)(ConfigurationForm);



// WEBPACK FOOTER //
// ./src/components/dashboard/clients/client/configuration/ConfigurationForm.js